import { $host, $authHost } from './index'
import { httpPoint } from '../utils/const'

export const add = async (linkData) => {
    if (localStorage.getItem('token')) {
        const { data } = await $authHost.post(httpPoint.links + 'add',{ data: linkData })
        return data
    }
}

export const getAllLinks = async (page = 1, limit = 24) => {
    if (localStorage.getItem('token')) {
        const { data } = await $authHost.get(httpPoint.links + 'all', {
            params: {
                page, limit
            }
        })
        return data
    }
}

